export const CUSTOMER_STATUS = {
    'Very Poor': '#df3030',
    'Poor': '#e46d37',
    'Fair': '#f2a818',
    'Good': '#0bc196',
    'Uncompleted': '#73839c',
}

export const BASKET_COLOR = {
    'Green': '#0BC196',
    'Yellow': '#F2A818',
    'Orange': '#F26B09',
    'Pink': '#F209DF',
    'Red': '#BB342C',
    'Silver': '#73839C',
}

export const UNIT_COLOR = {
    'Open': '#409EFF',
    'Reserved': '#67C23A',
    'Booked': '#909399',
    'Locked': '#E6A23C',
    'Sold': '#F56C6C',
    'Not Available': '#FFD600',
}

export const CASE_COLOR = {
    'Reserve': '#00EAD9',
    'Bank Processing': '#ED7E57',
    'Bank Approval': '#29B3FF',
    'Lawyer Processing': '#FBC00E',
    'SOLD': '#138B83',
    'Completed': '#00C4B0',
    'Cancelled': '#E43D40',
    'Revoke': '#999999',
    'Application Rejected': '#FF4560',
    'Rejected': '#FF4560',
    'Declined by client': '#FF4560', 
    'Application Pending': '#FFFFFF'
}

export const IP_STATUS_COLOR = {
    'Approved by Credit Control': '#0BC196', 
    'Converted to Case': '#0BC196',
    'Rejected by SSA': '#DC3545',
    'Rejected by Credit Control': '#DC3545',
}

export const PACKAGE_COLOR = {
    'basic': {
        background: '#5E72E4',
        color: '#fff'
    },
    'team': {
        background: '#10E052',
        color: '#000'
    },
    'corporate': {
        background: '#FEC823',
        color: '#000'
    },
}